import {PAdbContext} from "../PA.Core/PAdbContext";

export interface IProductCreateLoadOptions {
    // Load Options
    dbContext?: PAdbContext
    wbPrdMId?: number

    // Create Options
    wbMasterDataSetId?: number
    sId?: string
    sKeySetId?: string
    sName?: string
    sEntityType?: string,

    wbSalesAreaId?: number | number[]
    wbSourceId?: number
}


export interface IProductType {
    id: number,
    id_ui: string,
    name: string,

    bSalesAreaShowInd: boolean
    bSalesAreaSearchByInd: boolean

    bStatusShowInd: boolean
    bStatusSearchByInd: boolean

    bProductSizesShowInd: boolean,
    bProductSizesSearchByInd: boolean,

    bConsumerUPCShowInd: boolean,
    bConsumerUPCSearchByInd: boolean,

    bUOMShowInd: boolean,
    bUOMSearchByInd: boolean,

    bBOMShowInd: boolean,
    bBOMSearchByInd: boolean,

    ProductFieldsShowInd: {
        [id:string]: boolean
    },

    SalesAreaFieldsShowInd: {
        [id:string]: boolean
    },

}

// These fields should align with the domain, Customer_Header_Attributes
export const ProductHeaderFields: string[] = [

]

export const ProductGroupHeaderFields: string[] = [

]

